import axios from 'axios';
import DancerService from '../services/DancerService';
import SkillService from '../services/SkillService';
import PositionService from '../services/PositionService';

const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * API pour la gestion des sessions
 */
export const sessionApi = {
  // Session
  async fetchSession(sessionId, accessToken) {
    const response = await axios.get(`${API_BASE_URL}/sessions/${sessionId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response.data;
  },

  // Optimization
  async runOptimization(sessionId, timeLimit, initialTemp, coolingRate, forcedPosition, abortSignal, optimizationSettings = {}) {
    const response = await axios.post(
      `${API_BASE_URL}/sessions/${sessionId}/optimize`,
      { 
        time_limit: timeLimit, 
        initial_temp: initialTemp, 
        cooling_rate: coolingRate, 
        forcedPosition,
        use_time_weighting: optimizationSettings.useTimeWeighting ?? true,
      },
      { signal: abortSignal }
    );
    return response.data;
  },

  // Positions
  async createPosition(sessionId, periodId, x, y) {
    const response = await axios.post(
      `${API_BASE_URL}/sessions/${sessionId}/periods/${periodId}/positions`,
      { x, y }
    );
    return response.data;
  },

  async updatePosition(sessionId, positionId, data) {
    const response = await axios.put(
      `${API_BASE_URL}/sessions/${sessionId}/positions/${positionId}`,
      data
    );
    return response.data;
  },

  async deletePosition(sessionId, positionId) {
    await axios.delete(`${API_BASE_URL}/sessions/${sessionId}/positions/${positionId}`);
  },

  async associateSkillToPosition(sessionId, posId, skillId) {
    return await PositionService.associateSkill(sessionId, posId, skillId);
  },

  async removeSkillFromPosition(sessionId, posId, skillId) {
    return await PositionService.removeSkill(sessionId, posId, skillId);
  },

  // Periods
  async createPeriod(sessionId, name) {
    const response = await axios.post(
      `${API_BASE_URL}/sessions/${sessionId}/periods`,
      { name }
    );
    return response.data;
  },

  async deletePeriod(sessionId, periodId) {
    await axios.delete(`${API_BASE_URL}/sessions/${sessionId}/periods/${periodId}`);
  },

  async dissociateAllDancers(sessionId, periodId) {
    await axios.put(
      `${API_BASE_URL}/sessions/${sessionId}/periods/${periodId}/dissociate_all_dancers`
    );
  },

  // Dancers
  async createDancer(sessionId, name) {
    return await DancerService.createDancer(sessionId, { name });
  },

  async deleteDancer(sessionId, dancerId) {
    await DancerService.deleteDancer(sessionId, dancerId);
  },

  async associateSkillToDancer(sessionId, dancerId, skillId) {
    return await DancerService.associateSkill(sessionId, dancerId, skillId);
  },

  async dissociateSkillFromDancer(sessionId, dancerId, skillId) {
    return await DancerService.removeSkill(sessionId, dancerId, skillId);
  },

  // Skills
  async createSkill(sessionId, name, color) {
    return await SkillService.createSkill(sessionId, { name, color });
  },

  async deleteSkill(sessionId, skillId) {
    await SkillService.deleteSkill(sessionId, skillId);
  },

  // Music
  async uploadMusic(sessionId, file, accessToken) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("session_id", sessionId);

    const response = await axios.post(`${API_BASE_URL}/musics`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  },

  async deleteMusic(sessionId, musicId, accessToken) {
    await axios.delete(`${API_BASE_URL}/sessions/${sessionId}/musics/${musicId}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  },
};
